import React from 'react';

const IconClose: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9902 11.9998L20.1612 4.82781C20.4352 4.55481 20.4352 4.11181 20.1612 3.83781C19.8882 3.56481 19.4452 3.56481 19.1712 3.83781L12.0002 11.0098L4.82817 3.83781C4.55517 3.56481 4.11217 3.56481 3.83817 3.83781C3.56517 4.11181 3.56517 4.55481 3.83817 4.82781L11.0102 11.9998L3.83817 19.1718C3.56517 19.4448 3.56517 19.8878 3.83817 20.1618C3.97517 20.2988 4.15417 20.3668 4.33317 20.3668C4.51217 20.3668 4.69217 20.2988 4.82817 20.1618L12.0002 12.9898L19.1712 20.1618C19.3082 20.2988 19.4872 20.3668 19.6662 20.3668C19.8452 20.3668 20.0252 20.2988 20.1612 20.1618C20.4352 19.8878 20.4352 19.4448 20.1612 19.1718L12.9902 11.9998Z"
      fill="currentColor"
    />
  </svg>
);

export default IconClose;
